module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addQuestion":"Add question","additional":"Additional questions","subhead":"Do you want to ask a question? Try to find it in the library first.","cancel":"Cancel","save":"Save"}}')
  delete Component.options._Ctor
}
